window.addEventListener('DOMContentLoaded', function() {
    const slider = document.getElementById('slider');
    const slides = slider.getElementsByTagName('li');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    const checkInterval = setInterval(() => {
      // 記事リストの親要素を取得
      const articleListWrap = document.querySelector('.article-list[data-targets]');
      if (articleListWrap && articleListWrap.querySelectorAll('li').length > 0) {
        // スライダーの画像を取得
        getSliderPictures(articleListWrap);
        clearInterval(checkInterval);
      }
    }, 500);
    setTimeout(() => {
      clearInterval(checkInterval);
    }, 60000);
 
    let currentIndex = 2; // 先頭2つがクローンのため
    let isTransitioning = false;
    let autoTimer = setInterval(nextSlide, 5000);

    prevBtn.onclick = prevSlide; // 次へ
    nextBtn.onclick = nextSlide; // 前へ
    updateSlider(false);         // スライダーの更新

    window.addEventListener('resize', () => updateSlider(false));

    /**
     * スライダーの画像を取得
     * @returns 
     */
    function getSliderPictures(articleListWrap) {
      const sliderSection = document.querySelector('.slider-wrap');
      if (!articleListWrap) {
        if (sliderSection) {
          sliderSection.style.display = 'none';
        }
        return;
      }

      // リスト内のli要素を取得
      const listItems = articleListWrap.querySelectorAll('li');
      const sliderData = [];

      // li要素から上位6個の画像を取得
      for (let i = 0; i < listItems.length; i++) {
        if (sliderData.length >= 6) break;

        const link = listItems[i].querySelector('a');
        const img = link ? link.querySelector('img') : null;
        const srcAttr = img ? img.getAttribute('src') : null;

        if ((img && srcAttr && srcAttr.trim() !== "") && (link && link.href)) {
          sliderData.push({
            src: img.src,
            link: link.href
          });
        }
      }

      if (sliderData.length === 0) {
        if (sliderSection) {
          sliderSection.style.display = 'none';
        }
        return;
      }

      Array.from(slides).forEach(li => {
        const match = li.className.match(/item(\d+)/);
        if (match) {
          const index = parseInt(match[1], 10) - 1;
          const data = sliderData[index % sliderData.length];
          if (data) {
            li.style.backgroundImage = `url(${data.src})`;
            const sliderLink = li.querySelector('.slider-link');
            if (sliderLink) {
              sliderLink.href = data.link;
            }
          }
        }
      });
    }

    /**
     * スライダーの更新処理
     * @param {*} hasAnimation 
     */
    function updateSlider(hasAnimation = true) {
        const transitionVal = hasAnimation ? 'all 0.5s ease-in-out' : 'none';
        slider.style.transition = transitionVal;
        
        Array.from(slides).forEach(li => {
            li.style.transition = transitionVal;
            li.classList.remove('active');

            const link = li.querySelector('.slider-link');
            if (link) {
              link.style.pointerEvents = 'none';
            }
        });

        if (slides[currentIndex]) {
            slides[currentIndex].classList.add('active');

            const activeLink = slides[currentIndex].querySelector('.slider-link');
            if (activeLink) {
              activeLink.style.pointerEvents = 'auto';
            }
          }
        
        // 移動の計算
        let movePercent = 0;
        const isPC = window.innerWidth > 640;
 
        if (isPC) {
          movePercent = (currentIndex * 30) - 30;
        } else {
          movePercent = currentIndex * 100;
        }
 
        slider.style.transform = `translateX(-${movePercent}%)`;
        
        if (!hasAnimation) {
            void slider.offsetWidth;
        }
    }

    /**
     * 移動先の処理
     * @param {*} targetIndex 
     */
    function teleportTo(targetIndex) {
      setTimeout(() => {
          currentIndex = targetIndex;
          updateSlider(false); 
          isTransitioning = false;
      }, 500);
    }
 
    /**
     * 次へ（>）の処理
     * @returns 
     */
    function nextSlide() {
      if (isTransitioning) return;
      isTransitioning = true;
      currentIndex++;
      updateSlider(true);

      // 末尾のクローン群かどうか
      if (currentIndex === slides.length - 2) {
          // 実体の item01 に移動
          teleportTo(2);
      } else {
          setTimeout(() => { isTransitioning = false; }, 500);
      }
      resetTimer();
    }
 
    /**
     * 前へ（<）の処理
     * @returns 
     */
    function prevSlide() {
      if (isTransitioning) return;
      isTransitioning = true;
      currentIndex--;
      updateSlider(true);

      // 先頭のクローン群かどうか
      if (currentIndex === 1) {
          // 実体の item06 に移動
          teleportTo(slides.length - 3);
      } else {
          setTimeout(() => { isTransitioning = false; }, 500);
      }
      resetTimer();
    }
 
    /**
     * 自動移動のタイマーリセット
     */
    function resetTimer() {
      clearInterval(autoTimer);
      autoTimer = setInterval(nextSlide, 5000);
    }
});